<template lang="pug">
#modal-car-disponiveis
    el-dialog.modal-car-disponiveis-content(
        :visible.sync='dialogVisible',
        :close-on-click-modal='false',
        :close-on-press-escape='true',
        :destroy-on-close='true',
        :show-close='true',
        width='65%',
        @close='fecharModal'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalCarDisponiveis.titulo') }}

        .modal-car-disponiveis-content__container
            .container-header-table
                el-table(
                    :key="listagemTableKey('cars-disponiveis', dadosPaginado, paginaAtual)",
                    ref='tabelaCarDisponivelSubProdutoRef',
                    :data='dadosPaginado',
                )
                    el-table-column(
                        :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalCarDisponiveis.car")',
                    )
                        template(slot-scope='scope') {{ scope.row.codigo }}

                    el-table-column(
                        :label='`${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalCarDisponiveis.saldoDisponivel")} (t)`',
                        width='280'
                    )
                        template(slot-scope='scope') {{ scope.row.saldo }}

            .container-header-pagination
                .spans-paginacao
                    span.pagina
                        | {{ propriedadesSaldos?.length }} {{ $t('mensagens.comuns.registro') }}{{ propriedadesSaldos?.length > 1 ? 's' : '' }}

                el-pagination(
                    background,
                    :page-size='pageCount',
                    :current-page.sync='paginaAtual',
                    layout='prev, pager, next',
                    :total='propriedadesSaldos?.length',
                    @current-change='mudarPagina'
                )
</template>

<script>
export default {
    name: 'ModalCarsDisponiveis',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        propriedadesSaldos: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            paginaAtual: 1,
            pageCount: 10
        };
    },

    computed: {
        dialogVisible: {
            get() {
                return this.show;
            },
            set(value) {
                this.$emit('update:show', value);
            }
        },
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.propriedadesSaldos?.slice(inicio, fim) || [];
        }
    },

    methods: {
        resetModal() {
            this.paginaAtual = 1;
        },
        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },
        fecharModal() {
            this.resetModal();
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#modal-car-disponiveis {
    .modal-car-disponiveis-content {
        &__container {
            display: flex;
            height: 600px;
            flex-direction: column;
        }

        .el-dialog__header {
            padding: 20px;
            padding-bottom: 10px;
            background: var(--primary) !important;
            color: var(--white);
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
        }

        .el-dialog__body {
            padding: 0px !important;
            margin-bottom: 0px !important;
        }

        .el-dialog__headerbtn {
            display: flex;
            position: unset !important;
            top: 10px;
            right: 10px;
            z-index: 10;

            .el-dialog__close {
                color: #ffffff !important;
                font-size: 25px;
                visibility: visible !important;
                display: block !important;
            }
        }

        .el-dialog__headerbtn:hover .el-icon-close {
            color: #ffffff;
        }

        .modal-analise-elegibilidade--header {
            display: flex;
            align-items: center;
        }

        .container-header-table__infor {
            margin-bottom: 18px;

            .el-alert__title {
                color: #3b3b3b !important;
            }
        }

        .container-header-table {
            height: 100%;
            margin: 0 20px;

            h4 {
                margin-bottom: 16px;
            }

            .el-table {
                border-top-right-radius: 11px;
                border-top-left-radius: 11px;
                min-height: 140px;
                min-width: 800px;

                thead.has-gutter {
                    th.el-table__cell {
                        background-color: #fbfbfb;
                    }
                }

                .descricao-item-tabela {
                    margin-left: 55px;
                    margin-right: 55px;
                }

                .el-table .cell .el-checkbox__inner {
                    padding: 0px;
                }
            }
        }

        .container-header-pagination {
            margin-top: 0px !important;
            padding: 20px !important;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .spans-paginacao {
                display: flex;
                gap: 21px;
                color: #183b57;
                font-weight: bold;
            }
        }

        .btn-opcao {
            .el-button {
                min-width: 153px;
            }
        }
    }

    footer {
        display: flex;
        justify-content: space-between;

        .btn-opcao {
            margin-right: auto;

            .el-button {
                min-width: 153px;
            }
        }
    }
}
</style>
